module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "opera-cateringdetail"
  }, [_c('topNav', {
    attrs: {
      "title": _vm.$t('cateringDetail_title'),
      "url": "/opera/cateringOrder"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caterTop"
  }, [_c('p', {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.$t('cateringOrder_accnt')) + ": "), _c('span', [_vm._v(_vm._s(_vm.order.accnt))])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.$t('orderDetail_sta')) + "："), _c('span', [_vm._v(_vm._s(_vm.order.sta))])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "infoTop"
  }, [_c('i', {
    staticClass: "iconfont icon-changfangxingbiaoqian"
  }), _vm._v("\r\n        " + _vm._s(_vm.$t('cateringDetail_venue_info')) + "\r\n\r\n      ")]), _vm._v(" "), _c('ul', {
    staticClass: "infoContent clearfix "
  }, [_c('li', [_vm._v(_vm._s(_vm.$t('cateringDetail_hotelCode')) + ":"), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.order.hotelCode))])]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('cateringOrder_resName')) + ":"), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.order.resName))])]), _vm._v(" "), _c('li', [_vm._v("\r\n          " + _vm._s(_vm.$t('cateringDetail_shiftDes')) + ":"), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm._f("dateF")(_vm.order.bizDate)) + " " + _vm._s(_vm.order.shiftDes))])]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('cateringDetail_pccodeDes')) + ":"), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.order.pccodeDes))])]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('cateringDetail_type1Des')) + ":"), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.order.type1Des))])]), _vm._v(" "), _c('li', {
    staticClass: "twocol"
  }, [_vm._v(_vm._s(_vm.$t('cateringDetail_tablenoDes')) + ":"), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.order.tablenoDes) + " " + _vm._s(_vm.order.tableTypeDes))])]), _vm._v(" "), _c('li', {
    staticClass: "twocol"
  }, [_vm._v(_vm._s(_vm.$t('cateringDetail_exttableno')) + ":"), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.order.exttableno))])])])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "infoTop"
  }, [_c('i', {
    staticClass: "iconfont icon-changfangxingbiaoqian"
  }), _vm._v("\r\n        " + _vm._s(_vm.$t('cateringDetail_res_info')) + "\r\n      ")]), _vm._v(" "), _c('ul', {
    staticClass: "infoContent clearfix"
  }, [_c('li', {
    staticClass: "twocol"
  }, [_vm._v("\r\n          " + _vm._s(_vm.$t('cateringDetail_amount')) + ":"), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.order.amount) + " / " + _vm._s(_vm.order.typeDes))])]), _vm._v(" "), _c('li', {
    staticClass: "twocol"
  }, [_vm._v(_vm._s(_vm.$t('cateringDetail_numb')) + ":"), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm._f("intF")(_vm.order.numb)))])]), _vm._v(" "), _c('li', {
    staticClass: "twocol"
  }, [_vm._v(_vm._s(_vm.$t('cateringOrder_gsts')) + " :"), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.order.gsts))])]), _vm._v(" "), _c('li', {
    staticClass: "twocol"
  }, [_vm._v(" " + _vm._s(_vm.$t('cateringDetail_beginTime')) + ":"), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.order.beginTime))])]), _vm._v(" "), _c('li', {
    staticClass: "twocol"
  }, [_vm._v(_vm._s(_vm.$t('cateringDetail_modeDes')) + ":"), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.order.modeDes))])]), _vm._v(" "), _c('li', {
    staticClass: "twocol"
  }, [_vm._v(_vm._s(_vm.$t('cateringDetail_endTime')) + ":"), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.order.endTime))])]), _vm._v(" "), _c('li', {
    staticClass: "twocol"
  }, [_vm._v(_vm._s(_vm.$t('cateringDetail_pay')) + ":"), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.order.pay))])]), _vm._v(" "), _c('li', {
    staticClass: "twocol"
  }, [_vm._v(_vm._s(_vm.$t('cateringDetail_payTypeDes')) + ":"), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.order.payTypeDes))])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "clear": "both",
      "height": "auto"
    }
  }, [_vm._v(_vm._s(_vm.$t('cateringDetail_info')) + ":"), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.order.info))])])])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "infoTop"
  }, [_c('i', {
    staticClass: "iconfont icon-changfangxingbiaoqian"
  }), _vm._v("\r\n        " + _vm._s(_vm.$t('cateringDetail_con_info')) + "\r\n\t\t\t")]), _vm._v(" "), _c('ul', {
    staticClass: "infoContent clearfix ",
    staticStyle: {
      "border-bottom": "none"
    }
  }, [_c('li', {
    staticClass: "twocol"
  }, [_vm._v(_vm._s(_vm.$t('cateringDetail_linkMan')) + ":"), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.order.linkMan))])]), _vm._v(" "), _c('li', {
    staticClass: "twocol"
  }, [_vm._v(_vm._s(_vm.$t('cateringDetail_phone')) + ":"), _c('span', {
    staticClass: "infoVal"
  }, [_c('a', {
    attrs: {
      "href": "tel:" + _vm.order.phone
    }
  }, [_vm._v(_vm._s(_vm.order.phone))])])]), _vm._v(" "), _c('li', {
    staticClass: "twocol"
  }, [_vm._v(_vm._s(_vm.$t('cateringDetail_haccntName')) + ":"), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.order.haccntName))])]), _vm._v(" "), _c('li', {
    staticClass: "twocol",
    staticStyle: {
      "clear": "both"
    }
  }, [_vm._v(_vm._s(_vm.$t('cateringDetail_love')) + ":"), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.order.love))])]), _vm._v(" "), _c('li', {
    staticClass: "twocol",
    staticStyle: {
      "clear": "both"
    }
  }, [_vm._v(_vm._s(_vm.$t('cateringDetail_cusinfo')) + ":"), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.order.cusinfo))])]), _vm._v(" "), _c('li', {
    staticClass: "twocol",
    staticStyle: {
      "clear": "both"
    }
  }, [_vm._v(_vm._s(_vm.$t('cateringDetail_cardNo')) + ":"), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.order.cardNo))])]), _vm._v(" "), _c('li', {
    staticClass: "twocol"
  }, [_vm._v(_vm._s(_vm.$t('cateringDetail_cardName')) + ":"), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.order.cardName))])]), _vm._v(" "), _c('li', {
    staticClass: "twocol"
  }, [_vm._v(_vm._s(_vm.$t('cateringDetail_saleInfo')) + ":"), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.order.saleInfo))])]), _vm._v(" "), _c('li', {
    staticClass: "twocol"
  }, [_vm._v(_vm._s(_vm.$t('cateringDetail_marketDes')) + ":"), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.order.marketDes))])]), _vm._v(" "), _c('li', {
    staticClass: "twocol"
  }, [_vm._v(_vm._s(_vm.$t('cateringDetail_sourceDes')) + ":"), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.order.sourceDes))])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-8eb53fdc","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/operaPage/cateringDetail.vue
// module id = 1819
// module chunks = 107